import {
  IonContent,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  useIonViewDidEnter,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from '@ionic/react';
import React, { useState } from 'react';
import useEnhancedAuth from '../EnhancedAuth';
import './Default.css';
import AppPageHeader from '../components/AppPageHeader';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { apiUrpassGetTickets } from '../services/urpass';
import UrpassTicketView from '../usecases/urpass/UrpassTicketView';
import { LoadingController } from '../utils/LoadingController';
import { UrpassTicketType } from '../services/types/urpassapitypes';
import { apiGetUser } from '../services/api';

const UrpassviewPage: React.FC = () => {
  const auth = useEnhancedAuth();
  const router = useHistory();
  const [t] = useTranslation('global');

  const { agencyid, ticketid } = useParams<{
    agencyid: string;
    ticketid: string;
  }>();

  const [ticket, setTicket] = useState<UrpassTicketType | undefined>();
  const [owner, setOwner] = useState<string | undefined>(undefined);

  const loadDataFromApi = async () => {
    LoadingController.show();
    try {
      const [ticketResponse, userResponse] = await Promise.all([
        apiUrpassGetTickets(auth),
        apiGetUser(auth),
      ]);
      setTicket(
        ticketResponse.data.find(
          (ticket: UrpassTicketType) =>
            ticket.urpassTenantId == agencyid && ticket.id == ticketid,
        ),
      );

      setOwner(userResponse.data.firstName + ' ' + userResponse.data.lastName);
    } catch (e) {
      console.log('Error occurred while retrieving data', e);
    } finally {
      LoadingController.hide();
    }
  };

  const [isPageActive, setIsPageActive] = useState(false);
  useIonViewDidEnter(() => {
    setIsPageActive(true);
  });
  useIonViewWillLeave(() => {
    setIsPageActive(false);
  });

  // dont use useEffect, it does not trigger the second time a page with the same parameter is loaded.
  // we want the page to reload the current data every time it is opened
  useIonViewWillEnter(() => {
    loadDataFromApi();
  }, [auth.isLoading]);

  const refresh = (e: CustomEvent) => {
    loadDataFromApi().then(() => e.detail.complete());
  };

  return (
    <IonPage id="urpass-page">
      <>
        <AppPageHeader
          isPageActive={isPageActive}
          back={() => router.push('urpass')}
          title={t('urpass.title')}
        ></AppPageHeader>
        <IonContent fullscreen className="ion-padding default-content">
          <IonRefresher slot="fixed" onIonRefresh={refresh}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
          <div className="ion-text-center">
            {ticket && <UrpassTicketView ticket={ticket} owner={owner} />}
          </div>
        </IonContent>
      </>
    </IonPage>
  );
};

export default UrpassviewPage;
